@if (configuration.location) {
  <div class="preview-container" id="preview-container" [style.background-image]="backgroundImageUrl"></div>
}
